<template>
  <div>
    <div class="images-container">
      <div>
        <div class="d-flex align-items-center side-frame-success mt-3">
          <span
            class="side-frame-text"
            style="font-size: 15px;font-weight: 700"
          >
            {{ $l('form_label_storeImage') || '店铺图片' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <div v-if="!disabled">
            <el-upload
              id="uploader"
              ref="uploader"
              multiple
              action="#"
              :file-list="listImageFile"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="uploadChange"
              accept=".jpeg,.jpg,.png,.gif"
            >
              <b-button class="mr-2" size="sm" variant="outline-primary"
                ><i class="el-icon-plus" />{{
                  $l('INDEX.btn_upload') || '上传'
                }}
              </b-button>
            </el-upload>
          </div>
          <div v-if="!disabled">
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="uploadBusinessCard"
              ><i class="el-icon-plus" />{{
                $l('btn_upload_business_card') || '上传名片'
              }}
            </b-button>
          </div>
        </div>
      </div>

      <div class="d-flex flex-wrap block" v-if="!isEmpty || !disabled">
        <div v-for="(item, index) in listImage" :key="index">
          <div class="image-box">
            <span class="default-icon" v-if="item.isDefault === 'Y'">
              <i class="el-icon-success"></i>
            </span>
            <el-image
              style="width: 100%; height: 100%"
              fit="scale-down"
              :src="item.thumbImageUrl"
              :preview-src-list="listImageUrl"
            ></el-image>
            <div class="shadow">
              <div>
                <span @click="onImagePreview(index)">
                  <i class="el-icon-zoom-in"></i
                ></span>
                <span v-if="!disabled" @click="onImageCheck(item)" class="ml-2">
                  <i class="el-icon-check"></i
                ></span>
                <span
                  v-if="!disabled"
                  @click="uploadBusinessCard(item)"
                  class="ml-2"
                >
                  <i class="el-icon-document-checked"></i>
                </span>
                <span v-if="!disabled" @click="onImageDel(item)" class="ml-2">
                  <i class="el-icon-delete-solid"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
    <UploadBusinessCard
      v-if="businessCardOptions.visible"
      :visible.sync="businessCardOptions.visible"
      :resFabricScmCode="businessCardOptions.code"
      :resFabricRecordCode="businessCardOptions.resFabricRecordCode"
      :imageUrl="businessCardOptions.imageUrl"
      :imageCode="businessCardOptions.imageCode"
      :title="businessCardOptions.title"
      @reload="cardReload()"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import UploadBusinessCard from '../upload-business-card'
export default {
  mixins: [EditLoading],
  components: { UploadBusinessCard },

  props: {
    resFabricScmCode: { type: String, default: '' },
    resFabricRecordCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    title: {
      type: String,
      default: '图片维护',
    },
  },
  data() {
    return {
      listImage: [],
      listImageFile: [],
      uploadFileMaxLimit: 10,
      businessCardOptions: {
        visible: false,
        code: '',
        resFabricRecordCode: '',
        title: '',
        disabled: false,
        imageUrl: false,
        imageCode: false,
      },
    }
  },
  computed: {
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
    listImageUrl() {
      return this.isEmpty ? [] : this.listImage.map((item) => item.imageUrl)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.resFabricScmCode) return
      const res = await this.$api
        .resFabricScmImageListApi({
          resFabricScmCode: this.resFabricScmCode,
          resFabricRecordCode: this.resFabricRecordCode,
          isLocalImg: 'N',
        })
        .catch(() => null)
      this.listImage = res.body.data
    },
    uploadBusinessCard({ imageUrl, imageCode }) {
      this.businessCardOptions.visible = true
      this.businessCardOptions.code = this.resFabricScmCode
      this.businessCardOptions.resFabricRecordCode = this.resFabricRecordCode
      this.businessCardOptions.title = imageUrl
        ? this.$l('btn_identifying_business_card') || '识别名片'
        : this.$l('btn_upload_business_card') || '上传名片'
      this.businessCardOptions.imageUrl = imageUrl
      this.businessCardOptions.imageCode = imageCode
    },
    uploadChange(file) {
      const $uploader = this.$refs.uploader
      const uploader = $uploader.$el.querySelectorAll('input')[0]

      const listFile = uploader.files
      const fileCount = listFile.length

      if (fileCount > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 张图片，本次选择了 ${fileCount} 张图片`
        this.$message.warning(msg)
        this.clearFiles()
        throw new Error(msg)
      }
      this.listImageFile.push(file)
      if (this.listImageFile.length !== fileCount) return false
      this.upload()
    },
    async upload() {
      if (!this.listImageFile || !this.listImageFile.length) {
        this.$message.warning('请选择您需要上传的图片！')
        return
      }

      this.loadingOpen()
      const listImage = await this.uploadImages()
      if (listImage.includes(null)) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        this.clearFiles()
        return
      }
      const params = {
        resFabricScmCode: this.resFabricScmCode,
        resFabricRecordCode: this.resFabricRecordCode,
        listImage,
      }
      const res = await this.$api
        .resFabricScmImageUploadApi(params)
        .catch(() => null)
      this.loadingClose()
      this.clearFiles()
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.getData()
    },
    uploadImages() {
      if (!this.listImageFile || !this.listImageFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listImageFile.map(({ raw }) => {
        return this.$api
          .SYS_UPLOAD(raw)
          .then((res) => ({
            imageCode: res.body.fileId,
            imageUrl: res.body.url,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listImageFile = []
    },
    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },
    onImageDel({ resFabricScmImageCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .resFabricScmImageDelApi({ resFabricScmImageCode })
          .catch(() => null)
        this.loadingClose()
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.getData()
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
      })
    },
    async onImageCheck({ resFabricScmImageCode }) {
      this.loadingOpen()
      const res = await this.$api
        .resFabricScmImagSetDefaultApi({ resFabricScmImageCode })
        .catch(() => null)
      this.loadingClose()
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_set_no') || '设置失败！')
        return
      }
      this.getData()
      this.$emit('reloadScm')
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_set_ok') || '设置成功！',
        type: 'success',
      })
    },
    cardReload() {
      this.getData()
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
.images-container {
  height: 302px;
}

.side-frame-success {
  padding: 1px 5px 0 5px;
  border-left: 3px solid $color-primary;
  height: 26px;
}

.empty-image {
  height: 302px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-box {
  width: 140px;
  height: 140px;
  line-height: 140px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
  [class^='el-icon-'] {
    cursor: pointer;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
